import {allStates,replaceAll,replaceAllByArray} from './Helper';
const CommunityItem=(props)=>{

   
	let name=replaceAllByArray(props.item.name,[" inc",",","&#038;","&#8211;","&#8217;"],"");


	return (
		<>


		<div className="community-list">
			<div className="innerDiv">
		        <div className="h-bar">
		          <a style={{color:'#fff',textDecoration:'none'}} href={'/community-action-center-detail/'+props.item.myurl}><h4>{name}</h4></a>
		          <div className="s-icon">
		            <a href="#" className="iconTwitter"></a>
		            <a href="#" className="iconFacebook"></a>
		            <a href="#" className="iconLike"></a>
		          </div>
		        </div>
		        <div className="program"><span>Programs: </span>Housing, LIHEAP, WAP, SNAP, WIC</div>
	        </div>
	        <div className="c-view-detail"><a style={{color:'#fff',textDecoration:'none'}} href={'/community-action-center-detail/'+props.item.myurl}>View Detail <img src="/img/c-arrow-right.png" /></a></div>
      	</div>


		</>
		)
};
export default CommunityItem; 